<template>
  <div id="comp-bottom-tab">
    <div class="wrapper">
      <div id="for-dashboard" class="tab" @click="goPage('dashboard')">
        <div
          class="btn"
          :class="{ active: $store.state.selectedMainMenu === 'dashboard' }"
          @click="goPage('dashboard')"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
              class="st0"
              d="M12,3h7c1.1,0,2,0.9,2,2v14c0,1.1-0.9,2-2,2h-7 M12,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h7 M12,3v18 M21,12 h-9"
            />
          </svg>
          <span>Dashboard</span>
        </div>
      </div>

      <div
        id="for-rooms"
        class="tab"
        :style="updateRoomAndConnectionBtns()"
        @click="onRoomClick"
      >
        <div
          class="btn"
          :class="{ active: $store.state.selectedMainMenu === 'rooms' }"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
            <path
              d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
            ></path>
          </svg>
          <span>My Rooms</span>
        </div>
      </div>

      <div
        id="for-connections"
        class="tab"
        :style="updateRoomAndConnectionBtns()"
        @click="onConnectionClick"
      >
        <div
          class="btn"
          :class="{ active: $store.state.selectedMainMenu === 'connections' }"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
          <span>My People</span>
        </div>
      </div>

      <div id="for-more" class="tab" @click="openSetting">
        <div class="btn">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="1"></circle>
            <circle cx="19" cy="12" r="1"></circle>
            <circle cx="5" cy="12" r="1"></circle>
          </svg>
          <span>More</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/utils/common'
import UserService from '@/services/user-service'

export default {
  name: 'CompBottomTab',
  mixins: [common],
  methods: {
    updateRoomAndConnectionBtns() {
      if (this.$store.state.auth.isUserPermitAll) {
        return { opacity: 1.0 }
      }
      return { opacity: 0.2 }
    },
    onRoomClick() {
      if (!this.$store.state.auth.isUserPermitAll) {
        this.showVerifyDialog()
        return
      }
      this.goPageWithParams('Rooms', { listType: 'roomConnected' })
    },
    onConnectionClick() {
      if (!this.$store.state.auth.isUserPermitAll) {
        this.showVerifyDialog()
        return
      }
      this.goPageWithParams('Connections', { listType: 'connected' })
    },
    openSetting() {
      if (this.$parent.settingEditProfile === true) {
        this.$parent.settingEditProfile = false
      } else {
        this.$parent.settingEditProfile = true
      }
    },
    showVerifyDialog() {
      UserService.getMilestone().then((data) => {
        var isPermitAllow = true
        data.list.forEach((milestone) => {
          if (milestone.milestoneSeqId === 2) {
            if (!milestone.isDone) isPermitAllow = false
          } else if (milestone.milestoneSeqId === 3) {
            if (!milestone.isDone) isPermitAllow = false
          }
        })
        if (data.list.length === 0) isPermitAllow = false
        this.$store.commit('setUserPermitAll', isPermitAllow)

        if (isPermitAllow) {
          this.$parent.showDialog('SUM', 'All features have been unlocked.')
        } else {
          this.$parent.showDialog(
            'Wait',
            'Please fill out your profile and verify E-mail.',
            () => {
              this.$EventBus.$emit('editProfile')
            }
          )
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" src="@/scss/comp-bottom-tab.scss" scoped></style>
